/**
 * @fileoverview Module for `src/partners/lib/affiliate.js`.
 */

import logger from '../../lib/logger';
import { getWithToken, postWithToken } from '../../lib/apiClient';
import { setUserPartners } from '../../lib/user';

/**
 * Affiliates the signed-in user with a partner, unless already affiliated, then refreshes the cached
 * partner list from the server. Failures are logged, not thrown.
 *
 * @param {Object} params
 * @param {Object} params.auth - Auth context.
 * @param {string} params.partnerSlug - Partner slug from the current route or partner page.
 * @returns {Promise<void>} Resolves after the requests settle.
 */
async function affiliateWithPartner({ auth, partnerSlug }) {
  if (!partnerSlug || !auth.isAuthenticated() || auth.getUserPartners().includes(partnerSlug)) {
    return;
  }
  try {
    await postWithToken('/v1/users/self/partners', { partner: partnerSlug, source: 'user_login' }, auth);
    // Cache the server's list: an unknown slug returns 200 without being inserted.
    const userPartners = await getWithToken('/v1/users/self/partners', auth);
    setUserPartners(userPartners.map(({ partner }) => partner));
  } catch (error) {
    logger.error(error);
  }
}

// eslint-disable-next-line import/prefer-default-export
export { affiliateWithPartner };
